import {createLucideIcon} from "lucide-react";

const CardSwipeIcon = createLucideIcon("CardSwipe", [
  ["path", { d: "m3.14 3.41 8.103-1.39a1.357 1.357 0 0 1 1.022.235 1.378 1.378 0 0 1 .558.897l2.157 12.844c.062.362-.022.733-.232 1.032-.21.3-.53.503-.888.564l-8.102 1.39a1.36 1.36 0 0 1-1.019-.238 1.385 1.385 0 0 1-.556-.895L2.02 5.006a1.397 1.397 0 0 1 .233-1.033 1.376 1.376 0 0 1 .888-.563v0Z", key: "card-swipe_top" }],
  ["path", { d: "m13.848 5 4.862 1.269c1.962.402 2.663 1.47 2.104 3.202l-2.582 10.792c-.377 1.526-1.343 2.046-2.9 1.561l-5.39-1.33c-.646-.15-1.293-.453-1.942-.907", key: "card-swipe_bottom" }],
]);

export { CardSwipeIcon as default };
